import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';


import App from './App';
import reportWebVitals from './reportWebVitals';
import {AlertProvider} from "./contexts/AlertContext";
import {ErrorToast} from "./components/error/ErrorToast";
import {ErrorProvider} from "./hooks/useError";
import {AuthProvider} from "react-oidc-context";
import {UserManager} from "oidc-client-ts";
import {ENV} from "./config";

const oidcConfig = {
    authority: ENV.OAUTH_AUTHORITY,
    client_id: ENV.OAUTH_CLIENT,
    redirect_uri: ENV.OAUTH_REDIRECT_URI,
    silent_redirect_uri: ENV.OAUTH_SILENT_REDIRECT_URI,
    scope: ENV.OAUTH_SCOPE,
    response_type: "code",
    automaticSilentRenew: true
}

const userManager = new UserManager(oidcConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider userManager={userManager}>
            <ErrorProvider>
                <AlertProvider>
                    <ErrorToast/>
                    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.16.15/dist/katex.min.css"
                          integrity="sha384-Htz9HMhiwV8GuQ28Xr9pEs1B4qJiYu/nYLLwlDklR53QibDfmQzi7rYxXhMH/5/u"
                          crossOrigin="anonymous"></link>
                    <App/>
                </AlertProvider>
            </ErrorProvider>
        </AuthProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
